export default __webpack_public_path__ + "static/media/agentes-da-alegria-2.8640b955.jpeg";